/**
 * Check if the company is subject to VAT
 * for common section can be used in the frontend and backend side
 * @param vatSystem
 * @returns
 */
export function isSubjectToVTA(vatSystem: string): boolean {
    return vatSystem !== "NotSubjectTo" && vatSystem !== "BelowTheThreshold";
}
